import config from '../../config';
import { request } from '../../libraries/request'
import { isObject } from '../../libraries/utils';

const getAll = (params = {}, token) => {
  console.log('SERVICES::BOOKINGS::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'created_at';
    params.order_direction = 'DESC';
  }

  return request({
    url: config.BASE_API_URL + config.API.BOOKINGS,
    accessToken: token,
    data: params,
  })
  .then(response => {
    /////////TOOD: SACAR CUANDO SE PARSEE EL JSON EN BACK////////////
    const _data = response.data.data.map(booking => {
      const {location, ranges} = booking.json_data
      if( ranges && (typeof ranges === 'string' || !Array.isArray(ranges) )){
        booking.json_data.ranges = [...JSON.parse(ranges)]
      }
      if( location && (typeof location === 'string' || !isObject(location) )){
        console.log("console.log", booking.json_data.location)
        booking.json_data.location = {...JSON.parse(location)}      
      }
      return booking           
    })
    response.data.data = [..._data]
    console.log('RETURN FROM API BOOKINGS___PARSED IF LOCATION AND RANGES NOT PARSED', _data);
   
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }

    
    return response;
  })
}

const save = (data, token) => {
  console.log('SERVICES::BOOKINGS::save', data, token);
  return request({
    url: config.BASE_API_URL + config.API.BOOKINGS,
    accessToken: token,
    method: 'POST',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (data, token) => {
  console.log('SERVICES::BOOKINGS::update', data, token);
  return request({
    url: config.BASE_API_URL + config.API.BOOKING.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (id, token) => {
  console.log('SERVICES::BOOKINGS::get', id, token);
  return request({
    url: config.BASE_API_URL + config.API.BOOKING.replace('{id}', id),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      /////////TOOD: SACAR CUANDO SE PARSEE EL JSON EN BACK////////////
      if(response.data.data.booking){  
        const location = response.data.data.booking.json_data.location
        const ranges = response.data.data.booking.json_data.ranges
        if( ranges && (typeof ranges === 'string' || !Array.isArray(ranges) )){
          response.data.data.booking.json_data.ranges = [...JSON.parse(ranges)]
        }
        if( location && (typeof location === 'string' || !isObject(location) )){
          response.data.data.booking.json_data.location = JSON.parse(location)
        }
        
        console.log('RETURN FROM API BOOKINGS___PARSED IF LOCATION AND RANGES NOT PARSED', response);
      }
    }
    return response;
  })

}

const del = (id, token) => {
  console.log('SERVICES::BOOKINGS::remove', id, token);
  return request({
    url: config.BASE_API_URL + config.API.BOOKING.replace('{id}', id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getAvailability = (data, token) => {
  console.log('SERVICES::BOOKINGS::getAvailability', data, token);
  return request({
    url: config.BASE_API_URL + config.API.AVAILABILITY.replace('{owner}', data.owner),
    accessToken: token,
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      /////////TOOD: SACAR CUANDO SE PARSEE EL JSON EN BACK////////////
      if(response.data.data.booking){
        const location = response.data.data.booking.json_data.location
        const ranges = response.data.data.booking.json_data.ranges
        if( ranges && (typeof ranges === 'string' || !Array.isArray(ranges) )){
          response.data.data.booking.json_data.ranges = [...JSON.parse(ranges)]
        }
        if( location && (typeof location === 'string' || !isObject(location) )){
          response.data.data.booking.json_data.location = JSON.parse(location)
        }
        
        console.log('RETURN FROM API AVAILABILITY', response);
      }
    
    }
    return response;
  })

}


export default {
  getAll,
  save,
  get,
  del,
  update,
  getAvailability,
};